import styled from 'styled-components';
import Column from '@sdk/components/ui/spacing/Column';

export const ActivityLogContainer = styled(Column)<{ open: boolean }>`
  transition: transform 0.3s ease;
  position: fixed;
  right: 0;
  top: 60px;
  bottom: 0;
  width: 245px;
  background: white;
  z-index: 998;
  transform: translateX(250px);
  box-shadow: ${({ theme }) => theme.boxShadows.bottomLight};

  ${({ open }) => (open ? 'transform: translateX(0px);' : '')}
`;

export const CloseButton = styled.div`
  margin-left: auto;
  cursor: pointer;

  &:not(:hover) {
    opacity: 0.8;
  }
`;

export const ActivityLogList = styled(Column)`
  overflow: auto;
  max-height: calc(100% - 60px);
`;

export const ActivityLogEmptyStateContainer = styled(Column)`
  align-items: center;
  height: 100%;
  justify-content: center;
  padding: 0 20px;
`;
